type AnchorType = { id: any; anchor: HTMLElement; section: HTMLElement | null };

const selectors: Record<"anchors", string> = {
  anchors: "[data-anchor]",
};

const elements: Record<"anchors", null | HTMLElement | HTMLElement[] | AnchorType[]> = {
  anchors: null,
};

const initAnchors = (anchors: AnchorType[]) => {
  const paddingScrollTop = 80;

  const observer = new IntersectionObserver(
    () => {
      const firstVisibleSection = anchors.find(
        // @ts-ignore
        (anchor) => anchor.section.getBoundingClientRect().bottom >= paddingScrollTop
      );

      anchors.forEach((anchor) =>
        anchor.anchor.setAttribute(
          "data-anchor",
          // @ts-ignore
          firstVisibleSection && anchor.id === firstVisibleSection.id
        )
      );
    },
    {
      root: null,
      rootMargin: `-${paddingScrollTop}px 0px 0px`,
      threshold: [0, 1],
    }
  );

  anchors.forEach((anchor) => anchor.section && observer.observe(anchor.section));
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const anchors = Array.from(document.querySelectorAll(selectors.anchors) || []) as HTMLElement[];

    elements.anchors = anchors.map((anchor) => {
      return {
        // @ts-ignore
        id: anchor.hash.slice(1),
        anchor: anchor,
        // @ts-ignore
        section: document.getElementById(anchor.hash.slice(1)),
      };
    });

    if (elements.anchors.length) initAnchors(elements.anchors);
  },
  {
    once: true,
  }
);
